<section class="invitation-banner">
  <div class="container">
    <div class="row align-items-center justify-content-between">
      <div class="col-lg-7">
        <div class="invite-text">
          <img
            src="{{ myLinksS3URL }}frontend/presentation9/images/banner.png"
            alt=""
            class="img-fluid"
          />
          <img
            src="{{ myLinksS3URL }}frontend/presentation9/images/bird.png"
            alt=""
            class="img-fluid banner-bird"
          />
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation9/images/banner-element.png"
            alt=""
            class="img-fluid banner-element"
          />
        </div>
      </div>
      <div class="col-lg-5">
        <div class="heading banner-content">
          <h5 class="text-uppercase">YOU GET ONE LIFE. MAKE IT WORTHY</h5>
          <h1 class="rt im d-block text-uppercase">
            WE WELCOME YOU TO EXPERIENCE THE UNBELIEVABLE!
          </h1>
          <h5 class="text-uppercase">You Are Invited By : {{ userName }}</h5>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="greeting-section">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 text-left text-sm-center">
        <div class="greeting">
          <h1>
            Welcome to the
            <span> True Marketers Miracle </span>
            <img
              src="{{ myLinksS3URL }}frontend/presentation9/images/bird.png"
              alt=""
              class="img-fluid static-bird"
            />
          </h1>

          <ul>
            <li>Build and expand your business..</li>
            <li>Work less and earn more..</li>
            <li>Replace and secure your income..</li>
          </ul>

          <!-- <a [routerLink]="'.'" [queryParams]="{id: referralId}"
            [fragment]="'reg_form'" class="invitation-btn mt-3  " data-aos="fade-up" data-aos-delay="400" data-aos-duration="500">Become A Founder Now
                        </a> -->
        </div>
      </div>
    </div>

    <div class="row align-items-center">
      <div class="col-lg-8">
        <div class="line">
          <img
            src="{{ myLinksS3URL }}frontend/presentation9/images/last.png"
            alt=""
            class="img-flouid"
          />
        </div>
      </div>

      <div class="col-lg-6">
        <div class="first-video-text">
          <p>
            Enjoy long-term residual payments by harvesting the power of the
            Internet along with the right tools, best guidance and the perfect
            system that makes it happen.
          </p>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="greeting-one-spin">
          <h1 class="font-weight-bold">WIN BIG IN 2020</h1>
          <p>THE CONCEPT OF WORKING AND EARNING ONLINE IS NOW A REALITY.</p>

          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation9/images/banner-element-small.png"
            alt=""
            class="img-fluid banner-element-s"
          />
        </div>
      </div>
    </div>
  </div>
</section>

<section class="oppourtinity">
  <div class="container">
    <div class="row align-items-center no-gutters">
      <div class="col-lg-6">
        <div class="video-wrap">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation9/images/banner-element-small.png"
            alt=""
            class="img-fluid banner-element-s"
          />
          <a
            href="#"
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target="#myModal1"
          >
            <img
              src="{{ myLinksS3URL }}frontend/presentation9/images/video.png"
              alt=""
              class="img-fluid static-video"
            />
          </a>
        </div>
      </div>

      <div class="col-lg-6 text-white">
        <div class="goldmine">
          <h1>ENJOY THE GOLDMINE OF RESIDUAL INCOME FOR LIFE</h1>
          <h6 class="font-weight-normal">
            Run your business in full auto-pilot mode with following benefits:
          </h6>

          <ul>
            <li>AUTOPILOT...ADVERTISING</li>
            <li>AUTOPILOT....MARKETING</li>
            <li>AUTOPILOT...LEADS</li>
            <li>AUTOPILOT...SIGNUPS</li>
            <li>AUTOPILOT....RECRUITING</li>
            <li>AUTOPILOT...TEAM BUILDING</li>
          </ul>

          <p>
            Get acquainted with our innovative business strategy, the greatest
            opportunity so far in the history of internet marketing.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="believe">
  <div class="container">
    <div class="row align-items-center no-gutters">
      <div class="col-lg-6">
        <div class="believe-text">
          <h1 class="text-uppercase">
            Do you believe in the power of the internet and the concept of
            working from home ?
          </h1>

          <h6 class="font-weight-normal">
            Our unique strategy gives you an opportunity to change your life for
            BETTER by availing you:
          </h6>

          <h5 class="">
            No Requirements | No Recruiting | No Auto-ship | No Monthly Fees
          </h5>

          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'regform'"
            class="invitation-btn mt-3"
            >Become A Founder Now
          </a>

          <h3>WHY JOIN US NOW?</h3>
          <p>
            It takes only $97 to join us which otherwise costs $997. Yes! We are
            giving you 90% discount now as pre-launch offer. If you want to join
            us later, we cannot promise the availability of seats.
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="believe-video">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation9/images/banner-element-small.png"
            alt=""
            class="img-fluid banner-element-s"
          />
          <a
            href="#"
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target="#myModal2"
          >
            <img
              src="{{ myLinksS3URL }}frontend/presentation9/images/video2.png"
              alt=""
              class="img-fluid"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="r-steps">
  <div class="container text-white text-center">
    <h1>REGISTER WITH US IN THESE 2 STEPS</h1>
    <div class="row">
      <div class="col-xl-3 col-lg-4">
        <div class="promise">
          <p>
            JOIN US TODAY AND WE PROMISE THAT YOU WILL NEVER REGRET THE DECISION
          </p>
        </div>
      </div>
    </div>

    <div class="row justify-content-end mtop-100">
      <div class="col-lg-7">
        <div class="believe-video r-steps-video">
          <img
            src="{{
              myLinksS3URL
            }}frontend/presentation9/images/banner-element-small.png"
            alt=""
            class="img-fluid banner-element-s"
          />
          <a
            href="#"
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target="#myModal3"
          >
            <img
              src="{{ myLinksS3URL }}frontend/presentation9/images/video3.png"
              alt=""
              class="img-fluid"
            />
          </a>
        </div>
      </div>

      <div class="col-lg-4 align-self-end ability">
        <div class="need">
          <p class="mb-0">
            No need to be a technical wizard. No need to have any technical
            ability
          </p>
        </div>

        <div class="need-p">
          <p class="mb-0">
            Get your own page and invite your friends and family who dream big
            to secure their earnings. Gain knowledge from the regular updates
            sent by Mr.Mufareh in your backoffice. Be assured that the plans
            will be a big success as he has a wide network of loyal resources to
            assist him.
          </p>
        </div>
      </div>
    </div>

    <div class="row basic-details">
      <div class="col-lg-10 text-left">
        <div class="row">
          <div class="col-lg-6">
            <div class="row align-items-center no-gutters">
              <div class="col-lg-2">
                <div class="number">01</div>
              </div>

              <div class="col-lg-7">
                <div class="number-p">
                  <p>
                    Sign up using your basic details and fill up the
                    registration form.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="row align-items-center no-gutters">
              <div class="col-lg-2">
                <div class="number">02</div>
              </div>

              <div class="col-lg-7">
                <div class="number-p">
                  <p>
                    Pay us through your preferred payment mode and secure the
                    position
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-lg-6">
            <a
              [routerLink]="'.'"
              [queryParams]="{ reg: referralId }"
              [fragment]="'regform'"
              class="invitation-btn mt-3"
            >
              Become A Founder Now
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="webinar">
  <div class="container text-center">
    <div class="row">
      <div class="col-lg-7">
        <img
          src="{{ myLinksS3URL }}frontend/presentation9/images/computer.png"
          alt=""
          class="img-fluid"
        />
      </div>
      <div class="col-lg-5">
        <div class="webinar-playback">
          <h1 class="text-uppercase">webinar</h1>
          <a
            href="#"
            class="play_back_button aos-init aos-animate"
            data-toggle="modal"
            data-backdrop="static"
            data-keyboard="false"
            data-target="#previous"
          >
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation6/images/play_button.png"
              alt="image"
            />
            PREVIOUS WEBINAR PLAYBACK
          </a>

          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'regform'"
            class="invitation-btn mt-3"
          >
            Become A Founder Now
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="second-option">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="welcome">
          <!-- <h2>WELCOME <br>
                                    O-Founders</h2> -->
          <div class="hurry-up">
            <h4>HURRY UP! Don't let go of this massive opportunity</h4>
            <ul>
              <li>3 X 10 FORCED MATRIX TO INFINITY</li>
              <li>INSTANT & DIRECT AUTOMATED PAYMENTS</li>
              <li>AUTOMATED SPILLOVERS & UPGRADES</li>
              <li>EVERYONE GETS PAID ON EVERYONE</li>
            </ul>
            <h3>Change the game! Change your life</h3>
            <div class="text-center">
              <a
                routerLink="/auth/login"
                class="invitation-btn mt-3"
                target="_blank"
                rel="noopener"
              >
                SIGN IN
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="register-form" id="regform">
          <img
            src="{{ myLinksS3URL }}frontend/presentation9/images/two.png"
            alt=""
            class="two-"
          />

          <div class="register-form-inner">
            <div class="heading-f text-center text-white">
              <h1>
                <img
                  src="{{
                    myLinksS3URL
                  }}frontend/presentation9/images/Register-Icon.png"
                  alt=""
                  class="img-fluid"
                />
                REGISTER
              </h1>
            </div>

            <!-- <div class="alert-success">



                                        <strong>Success!</strong> 


                                    </div> -->

            <div class="panel-group cst"></div>

            <form [formGroup]="registerForm">
              <div class="row reg">
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      class="log_in_fild"
                      placeholder="First Name"
                      formControlName="firstname"
                      required
                    /><br />
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'required'
                        ) && registerForm.controls['firstname'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      First Name Required.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 1, max 50 characters.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containOnlyNumbers'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containOnlySpecialChars'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only special characters are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveSpaces'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive spaces are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveDots'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dots are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveHyphens'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dashes are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveUnderScores'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive underscores are not allowed.
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      placeholder="Last Name"
                      class="log_in_fild"
                      formControlName="lastname"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'required'
                        ) && registerForm.controls['lastname'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Last Name Required.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 1, max 50 characters.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containOnlyNumbers'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containOnlySpecialChars'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only special characters are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveSpaces'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive spaces are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveDots'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dots are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveHyphens'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dashes are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveUnderScores'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive underscores are not allowed.
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group d-block">
                    <div class="password-block">
                      <input
                        matInput
                        placeholder="Password"
                        formControlName="password"
                        class="log_in_fild"
                        [type]="pwdToggle ? 'text' : 'password'"
                        required
                      />
                      <button
                        type="button"
                        class="password-icon"
                        (click)="pwdToggle = !pwdToggle"
                      >
                        <i
                          class="fal"
                          [ngClass]="{
                            'fa-eye': pwdToggle,
                            'fa-eye-slash': !pwdToggle
                          }"
                        ></i>
                      </button>
                    </div>
                    <span
                      *ngIf="
                        registerForm.controls['password'].hasError(
                          'required'
                        ) && registerForm.controls['password'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Password Required
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['password'].hasError('pattern')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Password should contain minimum 8 Characters and Atleast
                      one Uppercase, One Lowercase, one Number and one Special
                      Characters
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      placeholder="Email Address"
                      class="log_in_fild"
                      formControlName="email"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['email'].hasError('required') &&
                        registerForm.controls['email'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Email id Required.
                    </span>
                    <span
                      *ngIf="registerForm.controls['email'].hasError('pattern')"
                      class="failed-validation"
                      style="color: red"
                    >
                      Please enter valid email.
                    </span>
                    <!-- <span *ngIf="registerForm.controls['email'].hasError('maxLength')" 
                                   class="failed-validation" style="color: red">
                                    Email length sould be less than 100.
                                  </span>-->
                  </div>
                </div>
              </div>

              <div class="d-block form-group">
                <input
                  matInput
                  placeholder="Password"
                  formControlName="password"
                  class="log_in_fild"
                  type="password"
                  required
                />
                <span
                  *ngIf="
                    registerForm.controls['password'].hasError('required') &&
                    registerForm.controls['password'].touched
                  "
                  class="failed-validation"
                  style="color: red"
                >
                  Password Required.
                </span>
                <span
                  *ngIf="
                    registerForm.controls['password'].hasError('minlength')
                  "
                  class="failed-validation"
                  style="color: red"
                >
                  Password should be min 8 letters.
                </span>
                <span
                  *ngIf="registerForm.controls['password'].hasError('pattern')"
                  class="failed-validation"
                  style="color: red"
                >
                  Atleast one Uppercase, One Lowercase, one Number and one
                  Special Characters.
                </span>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="d-block form-group">
                    <select
                      formControlName="country_id"
                      required
                      class="log_in_fild"
                    >
                      <option value="">Select Country</option>
                      <option
                        *ngFor="let country of countriesList"
                        [value]="country.countryId"
                      >
                        {{ country.countryName }}
                      </option>
                    </select>
                    <span
                      *ngIf="
                        registerForm.controls['country_id'].hasError(
                          'required'
                        ) && registerForm.controls['country_id'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Plese Select Country
                    </span>
                  </div>
                </div>
              </div>

              <div class="text-center">
                <button
                  mat-raised-button
                  type="submit"
                  (click)="submitRegister()"
                  [disabled]="registerForm.invalid"
                  class="ibtn w-100"
                >
                  SignUp
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="register text-white text-center">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="testimonials_bg">
          <div class="container">
            <div class="testimonilas_box text-white">
              <div class="testimonial-container">
                <h1 class="te">TESTIMONIALS</h1>

                <div class="dk-container">
                  <div class="cd-testimonials-wrapper cd-container">
                    <ul class="cd-testimonials">
                      <owl-carousel-o [options]="customOptions">
                        <ng-template carouselSlide class="slider-item">
                          <li>
                            <div class="testimonial-content">
                              <div class="cd-author">
                                <img
                                  src="{{ cloudFrontUrl }}uploads/t2.png"
                                  alt="Author image"
                                />

                                <ul class="cd-author-info">
                                  <li>PRINCE <strong>OBI</strong></li>

                                  <li></li>
                                </ul>
                              </div>

                              <div class="testimonial-p">
                                <p>
                                  In my 19 years successful career in this
                                  space,I have never seen a business so full, so
                                  disruptive, so intriguing that everyone I
                                  approach is excited to belong.
                                </p>

                                <p>
                                  Did a Facebook post, alongside my WhatsApp
                                  campaign, on the founder position, that
                                  attracted 122 comments, 14 people have joined
                                  direct to me and in less than 48 hours, 59
                                  super qualified leads have submitted their
                                  email, requesting information to be founders,
                                  AND ALL THESE WITHOUT ANYTHING YET ONGROUND,
                                  not even a website. I am totally blown away
                                  and will build my final dynasty here in
                                  ONPASSIVE.
                                </p>
                              </div>
                            </div>
                          </li>
                        </ng-template>
                        <ng-template carouselSlide class="slider-item">
                          <li>
                            <div class="testimonial-content">
                              <div class="cd-author">
                                <img
                                  src="{{ cloudFrontUrl }}uploads/t1.png"
                                  alt="Author image"
                                />

                                <ul class="cd-author-info">
                                  <li>Tim <strong>Leach</strong></li>

                                  <li></li>
                                </ul>
                              </div>
                              <div class="testimonial-p">
                                <p>
                                  His drive and passion for creating a platform
                                  to help everyone from seasoned marketers to
                                  the "little guy" helped solidify my belief
                                  Then learning how we benefit financially with
                                  optional starting points, makes this an ideal
                                  model for anyone with a business who needs
                                  advertising.
                                </p>

                                <p>
                                  Thank you Ash for your vision and help for so
                                  many people around the world.
                                </p>
                              </div>
                            </div>
                          </li>
                        </ng-template>
                        <ng-template carouselSlide class="slider-item">
                          <li>
                            <div class="testimonial-content">
                              <div class="cd-author">
                                <img
                                  src="{{ cloudFrontUrl }}uploads/t4.png"
                                  alt="Author image"
                                />

                                <ul class="cd-author-info">
                                  <li>Mike <strong>Williams</strong></li>

                                  <li></li>
                                </ul>
                              </div>
                              <div class="testimonial-p">
                                <p>
                                  I want to personally say thank you to everyone
                                  on this awesome journey that Ash Murareh has
                                  created. As many of you may not know, Ash is a
                                  very successful online marketer and has made
                                  his living in this industry building massive
                                  teams for various companies. He saw a big need
                                  for creating a company that would help the
                                  average person succeed online so he decided to
                                  build it himself.
                                </p>

                                <p>
                                  When you listen to his Founder's presentations
                                  or when you speak with him, you will
                                  immediately feel his passion to build a highly
                                  effective business where every single person
                                  will be successful.
                                </p>
                              </div>
                            </div>
                          </li>
                        </ng-template>
                      </owl-carousel-o>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<footer class="site-footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-8">
        <h2 class="text-capitalize font-weight-bold mb-0">
          <img
            src="{{ myLinksS3URL }}frontend/presentation9/images/small-bird.png"
            alt=""
            class="img-fuild"
          />
          FOR A LITTLE WHILE YET, FOUNDER POSITIONS STILL AVAILABLE
        </h2>
        <p>Copyright &copy; 2022 All rights reserved | by O-Founders</p>
      </div>
    </div>
  </div>
</footer>

<!-- Modal 1 -->
<div id="myModal1" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="first_video_close"
          class="close"
          data-dismiss="modal"
          (click)="video1.pause(); video1.currentTime = 0"
        >
          &times;
        </button>
      </div>
      <video
        #video1
        id="my-video"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting1-new.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>
<!-- Modal 2 -->
<div id="myModal2" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="second_video_close"
          class="close"
          data-dismiss="modal"
          (click)="video2.pause(); video2.currentTime = 0"
        >
          &times;
        </button>
      </div>
      <video
        #video2
        id="my-video1"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/greetingsgofound/images/greeting2.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/Video2-Compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>
<!-- Modal 3 -->
<div id="myModal3" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="third_video_close"
          class="close"
          data-dismiss="modal"
          (click)="video3.pause(); video3.currentTime = 0"
        >
          &times;
        </button>
      </div>
      <video
        #video3
        id="my-video2"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting3-new.png"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="previous" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          id="prev_video_pause"
          (click)="video4.pause(); video4.currentTime = 0"
        >
          &times;
        </button>
      </div>
      <video
        #video4
        width="100%"
        class="video-js"
        controls
        preload="auto"
        poster="{{ myLinksS3URL }}videos/title.jpg"
        id="my-video"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          id="video"
          type="video/mp4"
        />
        Your browser does not support HTML5 video.
      </video>
    </div>
  </div>
</div>

<div class="country_popup_wrapper"></div>
